
import { combineReducers } from 'redux';

import {
    GET_OPSUB_ACTUAL_ACTION_TYPE
} from '../../sagas/analyzeDefunctPar';

import opsub from './opsub';

import analyze from './analyze';
import reducer from './reducer';

export function getAnalyze(state) {
    return state.analyze;
}

export function getDefault(state) {
    return state.default;
}

export function getOpsubActual(state) {
    return state.opsubActual;
}

export default combineReducers({
    default: reducer,
    analyze: analyze(),
    opsubActual: opsub(GET_OPSUB_ACTUAL_ACTION_TYPE),
});
